import {Injectable} from '@angular/core';
import {FromProviderResolverService} from '@abstract/from-provider-resolver.service';
import {TechnicalDocument, TechnicalDocumentsProvider} from '@providers/technical-documents/technical-documents.provider';

@Injectable()
export class TechnicalDocumentsResolverService extends FromProviderResolverService<TechnicalDocument[]> {
    protected cacheData = true;

    constructor(
        provider: TechnicalDocumentsProvider,
    ) {
        super(provider);
    }
}
